'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeBarIcon = function TraceTypeBarIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M7 28h6v12H7z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M32 28h6v12h-6zM15 10h6v30h-6z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M24 20h6v20h-6z' })
    );
};

exports.default = TraceTypeBarIcon;